import { Component, Input, OnDestroy, OnInit} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import { DataFilters } from 'src/app/models/DataFilters.model'
import {
  ASSET_CLASS_FILTERS,
  CREDIT_QUALITY_FILTERS,
  FILTER_MAP,
  INVESTMENT_MINIMUM_FILTERS,
  MANAGEMENT_STYLE_FILTERS,
  MARKET_CAPITALIZATION_FILTERS,
  MATURITY_FILTERS,
  PRODUCT_TYPE,
  REGION_FILTERS,
  SHARE_CLASS_FILTERS,
  STRATEGY_FILTERS,
  STRATEGY_FILTERS_529,
  STYLE_FILTERS,
  TAX_EFFICIENCY_FILTERS,
} from 'src/app/models/filter-details.model'
import { FiltersService } from 'src/app/services/filtersService.service'

import {FundDetailService} from "../../../services/fund-detail.service";

@Component({
  selector: 'filter-by',
  templateUrl: './filterBy.component.html',
  styleUrls: ['./filterBy.component.scss'],
})
export class FilterByComponent implements OnInit, OnDestroy {
  public readonly assetClassFilterLabels = ASSET_CLASS_FILTERS
  public readonly regionFilterLabels = REGION_FILTERS
  public readonly marketSubFilterLabels = MARKET_CAPITALIZATION_FILTERS
  public readonly styleSubFilterLabels = STYLE_FILTERS
  public readonly creditQualityFilterLabels = CREDIT_QUALITY_FILTERS
  public readonly maturityFilterLabels = MATURITY_FILTERS
  public readonly managementStyleFilterLabels = MANAGEMENT_STYLE_FILTERS
  public readonly shareClassFilterLabels = SHARE_CLASS_FILTERS
  public readonly investmentMinimumFilters = INVESTMENT_MINIMUM_FILTERS
  public readonly taxEfficiencyFilterLabels = TAX_EFFICIENCY_FILTERS
  public readonly strategyFilterLabels = STRATEGY_FILTERS
  public readonly strategy529FilterLabels = STRATEGY_FILTERS_529
  public readonly productTypeFilterLabels = PRODUCT_TYPE
  public readonly filterMap = FILTER_MAP
  public activeFilters: DataFilters

  private destroy$ = new Subject<void>();

  @Input() isNonVanguard : boolean
  @Input() isMobileResolution;
  public readonly minimumsMap = {
    '1-1000': '$1 - $1,000',
    '1000-3000': '$1,000 - $3,000',
    '3000-10000': '$3,000 - $10,000',
    '10000-25000': '$10,000 - $25,000',
    '25000-50000': '$25,000 - $50,000',
    '50000>': '$50,000 >',
    closed: 'Closed funds',
  }

  fundFamily: any;
  fundFamilyName: string;
  fundFamilyId: number;
  hasLoadFunds: any;
  hasNTFFunds: any;
  fundFamilySelection: any;
  fund: any;

  constructor(
    private readonly filtersService: FiltersService,
    public fundDetailService: FundDetailService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  public get isNonVanguardMutualFunds(): boolean {
    return this.filtersService.activeFilters.discoverBy === 'non-vanguard-mutual-funds'
  }

  ngOnInit() {
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const fundFamilyId = params['FundFamilyId'];

      this.activeFilters = this.filtersService.activeFilters

      if (fundFamilyId) {
        this.filtersService.FundFamilyId = fundFamilyId;
        this.getFamilyName();
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFamilyName(): void {
    this.fundDetailService.getfundFamily().pipe(take(1)).subscribe((response) => {
      this.fundFamily = response.fundFamily;

      const fundFamilyData = this.fundFamily.find(fund => Number(this.filtersService.FundFamilyId) === fund.fundFamilyId);

      if (fundFamilyData) {
        this.fundFamilyName = fundFamilyData.fundFamilyName;
        this.fundFamilyId = fundFamilyData.fundFamilyId;
        this.hasLoadFunds = fundFamilyData.hasLoadFunds;
        this.hasNTFFunds = fundFamilyData.hasNTFFunds;
        this.fundFamilySelection = `${this.fundFamilyName}${this.hasLoadFunds ? ' [Load]' : ''}${this.hasNTFFunds ? ' [NTF]' : ''}`;

        this.activeFilters.fundFamily = {
          id: this.fundFamilyId,
          name: this.fundFamilySelection,
        };
      }
    });
  }

  cleanFundFamilyId() {
    this.filtersService.activeFilters.fundFamily = {}
    this.filtersService.activeFilters.discoverBy = 'mutual-funds';
    this.filtersService.applyFilters()
  }

  clearFilters(): void {
    this.filtersService.clearFilters()
  }

  removeDiscoverBy() {
    this.activeFilters.discoverBy = 'all'
    this.filtersService.applyFilters()
  }

  removeFromArray(array, value): void {
    array.splice(array.indexOf(value), 1)
    this.filtersService.applyFilters()
  }
  // eslint-disable-next-line complexity
  areAllFiltersEmpty(): boolean {
    const isRiskEmpty = this.activeFilters.risk.length === 0
    const isAssetClassEmpty =
      ASSET_CLASS_FILTERS.filter(
        (value) => this.activeFilters.assetClass.controls[value].value,
      ).length <= 0

    const isShareClassArrayEmpty =
      SHARE_CLASS_FILTERS.filter(
        (value) => this.activeFilters.shareClass.controls[value].value,
      ).length <= 0
    const istaxEfficiencyArrayEmpty =
      TAX_EFFICIENCY_FILTERS.filter(
        (value) => this.activeFilters.taxEfficiency.controls[value].value,
      ).length <= 0
    const isManagementStyleArrayEmpty =
      MANAGEMENT_STYLE_FILTERS.filter(
        (value) => this.activeFilters.managementStyle.controls[value].value,
      ).length <= 0
    const isInvestmentMinimumsArrayEmpty =
      INVESTMENT_MINIMUM_FILTERS.filter(
        (value) => this.activeFilters.investmentMinimums.controls[value].value,
      ).length <= 0
    const isStrategyEmpty = STRATEGY_FILTERS.filter(
      (value) => this.activeFilters.strategy.controls[value].value,
    ).length <= 0
    const isStrategy529Empty =STRATEGY_FILTERS_529.filter(
      (value) => this.activeFilters.strategy529.controls[value].value,
    ).length <= 0
    const isProductTypeEmpty = PRODUCT_TYPE.filter(
      (value) => this.activeFilters.productType.controls[value].value,
    ).length <= 0
    const isRegionEmpty = REGION_FILTERS.filter(
      (value) => this.activeFilters.region.controls[value].value,
    ).length <= 0
    return (
      isRiskEmpty &&
      isAssetClassEmpty &&
      isManagementStyleArrayEmpty &&
      isShareClassArrayEmpty &&
      isInvestmentMinimumsArrayEmpty &&
      isStrategyEmpty &&
      istaxEfficiencyArrayEmpty &&
      isProductTypeEmpty &&
      isStrategy529Empty &&
      isRegionEmpty
    )
  }

  clearAssetClass(label) {
    this.activeFilters.assetClass.controls[label].setValue(false)
    if (label === 'equity') {
      this.setValueForMarketStyle(false)
    }
    if (label === 'fixed_income') {
      this.setValueForCreditMaturity(false)
    }
  }

  setValueForMarketStyle(value) {
    MARKET_CAPITALIZATION_FILTERS.forEach((market) => {
      this.activeFilters.assetClassMarketCap['equity'].controls[
        market
      ].setValue(value)
    })
    STYLE_FILTERS.forEach((style) => {
      this.activeFilters.assetClassStyle['equity'].controls[style].setValue(
        value,
      )
    })
  }
  setValueForCreditMaturity(value) {
    CREDIT_QUALITY_FILTERS.forEach((credit) => {
      this.activeFilters.assetClassCredit['fixed_income'].controls[
        credit
      ].setValue(value)
    })
    MATURITY_FILTERS.forEach((maturity) => {
      this.activeFilters.assetClassMaturity['fixed_income'].controls[
        maturity
      ].setValue(value)
    })
  }

  value: string;
  // eslint-disable-next-line complexity
  formatFilterValue(val) {
    if (val === 'sector_specialty') {
      return val.replace(/_/g, ' & ')
    }
    if (val === 'esg') {
      return 'ESG'
    } else if(val==="equity"){
      return 'Stocks'
    } else if(val==="multi_asset"){
      return 'Balanced'
    }
    if (val === 'total_market_etfs') {
      return 'Total market ETFs'
    }
    if (val === 'etfs') {
      return 'Vanguard ETFs'
    }
    if (val === 'mutual-funds') {
      return 'Vanguard Mutual funds'
    }
    if (val === 'us') {
      return 'US'
    } else {
      return val.replace(/_/g, ' ')
    }
  }
}
